import { c as _c } from "react/compiler-runtime";
import { BreadcrumbsData } from '@systemeio/ui';
import { CourseBundlesLoco } from 'modules/courses/bundles/constants/course-bundles-loco';
import AddCourseModal from 'modules/courses/bundles/course-bundle/components/add-course-modal';
import CourseBundleEmptyList from 'modules/courses/bundles/course-bundle/components/course-bundle-empty-list';
import CourseBundleSkeleton from 'modules/courses/bundles/course-bundle/components/course-bundle-skeleton';
import CourseBundleTable from 'modules/courses/bundles/course-bundle/components/course-bundle-table';
import { useCourseBundle } from 'modules/courses/bundles/course-bundle/hooks/user-course-bundle';
import { CourseBundleItemInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import BreadcrumbsDashboard from 'shared/components/breadcrumbs';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const CourseBundle: NextPage = () => {
  const $ = _c(29);
  const {
    t
  } = useLocoTranslation();
  const router = useRouter();
  const {
    courseBundleId
  } = router.query;
  const {
    courseBundleData,
    mutate
  } = useCourseBundle(courseBundleId as string);
  let t0;
  if ($[0] !== t) {
    t0 = t("dashboard.course_bundle.title_other");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      caption: t0,
      href: "/courses/bundles",
      isStatic: true
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = courseBundleData?.name || "";
  let t3;
  if ($[4] !== t2) {
    t3 = {
      caption: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = [t1, t3];
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const breadcrumbsData = t4;
  let t5;
  if ($[9] !== mutate) {
    t5 = async newItem => {
      await mutate(data => {
        if (data) {
          return {
            ...data,
            items: [...data.items, newItem]
          };
        }
      }, false);
    };
    $[9] = mutate;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const addCourseWithUpdate = t5;
  const t6 = !courseBundleData;
  let t7;
  if ($[11] !== breadcrumbsData || $[12] !== t6) {
    t7 = <BreadcrumbsDashboard data={breadcrumbsData} isFetching={t6} />;
    $[11] = breadcrumbsData;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = courseBundleId as string;
  const t9 = !courseBundleData;
  let t10;
  if ($[14] !== addCourseWithUpdate || $[15] !== t8 || $[16] !== t9) {
    t10 = <AddCourseModal addCourseWithUpdate={addCourseWithUpdate} courseBundleId={t8} disabled={t9} />;
    $[14] = addCourseWithUpdate;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7) {
    t11 = <div className="flex flex-col items-center justify-between gap-4 lg:flex-row lg:gap-5">{t7}{t10}</div>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== addCourseWithUpdate || $[22] !== courseBundleData || $[23] !== courseBundleId || $[24] !== mutate) {
    t12 = courseBundleData ? courseBundleData.items.length > 0 ? <CourseBundleTable items={courseBundleData.items} mutate={mutate} /> : <CourseBundleEmptyList addCourseWithUpdate={addCourseWithUpdate} courseBundleId={courseBundleId as string} disabled={!courseBundleData} /> : <CourseBundleSkeleton />;
    $[21] = addCourseWithUpdate;
    $[22] = courseBundleData;
    $[23] = courseBundleId;
    $[24] = mutate;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <div className="flex flex-col">{t11}{t12}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
export const getServerSideProps = getBaseServerSideProps(CourseBundlesLoco, 'header.top_menu.course_bundles');
export default CourseBundle;